import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { formatDistanceToNow } from 'date-fns';
import { Plus } from 'lucide-react';
import { ErrorAlert } from '@/components/ErrorAlert';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { ActionButton } from '@/components/ui+/ActionButton';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const Route = createFileRoute('/a/articles/')({
  component: Component,
});

function Component() {
  const navigate = useNavigate();
  const { data: articles, isPending, isError, error } = useQuery(api.articles.list);

  if (isError) return <ErrorAlert message={error.message} title="Error loading articles" />;
  if (isPending) return <LoadingIcon />;

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div className="space-y-1.5">
          <CardTitle>Articles</CardTitle>
          <CardDescription>
            Knowledge-base articles the sales and support AI agents draw on.
          </CardDescription>
        </div>
        <ActionButton
          onClick={() =>
            navigate({
              to: '/a/articles/$articleId',
              params: { articleId: 'new' },
            })
          }
        >
          <Plus className="h-4 w-4" />
          New article
        </ActionButton>
      </CardHeader>
      <CardContent>
        {articles.length === 0 ? (
          <div className="rounded-md border border-dashed p-6 text-center text-sm text-muted-foreground">
            No articles yet.
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Title</TableHead>
                <TableHead>Updated</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {articles.map((article) => (
                <TableRow
                  key={article._id}
                  className="cursor-pointer"
                  onClick={() =>
                    navigate({
                      to: '/a/articles/$articleId',
                      params: { articleId: article._id },
                    })
                  }
                >
                  <TableCell className="font-medium">{article.title}</TableCell>
                  <TableCell className="whitespace-nowrap text-muted-foreground">
                    {formatDistanceToNow(article.updatedAt, { addSuffix: true })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
